import React from "react";
import "./confirm.css";
import notvisited from "../../assets/icons/not-visited.png";
import notanswered from "../../assets/icons/not-answered.png";
import answered from "../../assets/icons/answered.png";
import notanswerreview from "../../assets/icons/not-answered-review.png";
import answerreview from "../../assets/icons/answered-review.png";
import Icon from "../../assets/icons/Icon.svg";
import { submitTestApi } from "../../services/saveAndNext";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";

const Confirm = (props) => {
  const { t } = useTranslation();
  const submitTest = (isMannualSubmit = 0) => {
    props.setShow(false);
    submitTestApi(props, isMannualSubmit);
  };

  return (
    <>
      {
        <div className="popup-box">
          <div class="modal-body-md">
            <div class="headerv">
              <img src={Icon} />
              <h2>
                {t('test.confirmSubmit')}
                <p>
                  {" "}
                  {t('test.submitWarning')}
                </p>
              </h2>
            </div>
            <div class="tt-8">
              <div>
                <img src={notvisited} /> {t('test.notVisited')}{" "}
                <span>
                  {
                    props.state.questionstatus.filter(
                      ({ status_number }) => status_number == 1
                    ).length
                  }
                </span>
              </div>
              <div>
                <img src={notanswered} /> {t('test.notAnswered')}{" "}
                <span>
                  {
                    props.state.questionstatus.filter(
                      ({ status_number }) => status_number == 2
                    ).length
                  }
                </span>
              </div>
              <div>
                <img src={answered} /> {t('test.answered')}{" "}
                <span>
                  {
                    props.state.questionstatus.filter(
                      ({ status_number }) => status_number == 4
                    ).length
                  }
                </span>
              </div>
              <div>
                <img src={notanswerreview} /> {t('test.markedForReview')}{" "}
                <span>
                  {
                    props.state.questionstatus.filter(
                      ({ status_number }) => status_number == 3
                    ).length
                  }
                </span>
              </div>
              <div>
                <img src={answerreview} /> {t('test.answeredAndMarked')}{" "}
                <span>
                  {
                    props.state.questionstatus.filter(
                      ({ status_number }) => status_number == 5
                    ).length
                  }
                </span>
              </div>
            </div>
            <div class="display">
              <button
                onClick={() => {
                  props.setShow(false);
                }}
              >
                {t('test.cancel')}
              </button>
              {/* {console.log("st",props.is_test_submit_status,sessionStorage.getItem("leftTimeToSubmit"))} */}
              {/* {console.log("props.is_test_submit_status",props.is_test_submit_status)} */}
              {((
                props.is_test_submit_status === 1 )
                
              ) ? (
                <button
                  onClick={() => {
                    submitTest(1);
                  }}
                >
                  {/* {console.log("yes")} */}
                  {t('test.submit')}
                </button>
              ) : (
                <div>
                                    {/* {console.log("no")} */}

                  <button>{t('test.submit')}</button>
                  <p
                    style={{ fontSize: "12px", color: "red", marginTop: "5px" }}
                  >
                    {t('test.cannotSubmitEarly')}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      }
    </>
  );
};

const mapStateToProps = (state) => ({ state: state });
export default connect(mapStateToProps)(Confirm);
